export enum UserProfileTabs {
  PERSONAL_DATA = "personalDataTab",
  ORGANISATION = "organisationTab",
  INSPECTION = "inspectionTab",
  BILLING = "billingTab",
  SECURITY = "securityTab",
  APP_SETTINGS = "appSettingsTab",
  INCIDENT = "incidentTab",
}
